import BytesTitle from '@components/local/bytes/BytesTitle';
import { useRef } from 'react';
import BytesCard from '../BytesCard';
import ViewAll from '../ViewAll';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Autoplay, Virtual } from 'swiper/core';
import 'swiper/swiper-bundle.css';
import { IsMobile } from '@lib/isMobile';
import { RiArrowRightSLine, RiArrowLeftSLine } from 'react-icons/ri';

SwiperCore.use([Navigation, Pagination, Autoplay, Virtual]);
const BytesTutorials = ({ className, relatedTutorials, data = [], meta = {}, handleLoadMore }) => {
  const { pagination } = meta;
  return (
    <div className={className}>
      {relatedTutorials ? (
        <>
          <BytesTitle
            title={'Top Learning Tutorials to'}
            highlight={'Master'}
            description={
              'Learn new skills with our selection of top tutorials covering beginner to advanced levels'
            }
            href="/bytes/tutorials"
          />
          <div className="relative">
            <Swiper
              // virtual
              slidesPerView={4}
              spaceBetween={40}
              breakpoints={{
                320: {
                  slidesPerView: 1.2,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
              }}
              navigation={{
                prevEl: '.tutorials-prev',
                nextEl: '.tutorials-next',
              }}
              pagination={{ clickable: true }}
              className="h-fit !pb-12 "
            >
              {' '}
              {data?.map((item, index) => (
                <SwiperSlide key={index}>
                  <BytesCard tutorialCard data={item} />
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="tutorials-prev custom-prev-button flex h-full w-full items-center justify-center text-red">
              <RiArrowLeftSLine size={60} className="my-auto text-red" />
            </div>
            <div className="tutorials-next custom-next-button flex h-full w-full items-center justify-center text-red">
              <RiArrowRightSLine size={60} className="my-auto text-red" />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="grid gap-10 md:grid-cols-3">
            {data?.map((item) => (
              <BytesCard key={item} data={item} tutorialCard href="/bytes/tutorials/abc" />
            ))}
          </div>
        </>
      )}

      {!relatedTutorials && data?.length < pagination?.total && (
        <button onClick={handleLoadMore} className="btn-red-outline center mx-auto mt-12 h-10">
          Load More
        </button>
      )}
    </div>
  );
};

export default BytesTutorials;
